import CONSTANTS from '../../../constants';

export function planograms(state = { data: null, loading: true }, action) {
  if (action.type === CONSTANTS.ACTIONS.PLANOGRAM.PLANOGRAM_ALL) {
    const { data } = action;
    return { data: data ? data.response : data, loading: action.loading};
  }
  return state;
}